import React, { FunctionComponent } from 'react';

import { HelpOthersCard } from './HelpOtherCard';
import config from '../../config';
import styles from './HelpOthers.module.scss';

export const HelpOthers: FunctionComponent = () => {
  return (
    <div className={`${styles.tileBanner} jg-space-ptsm`}>
      <div className="jg-grid-container">
        <section className="jg-grid-row">
          <h2 className={`jg-h1 ${styles.title}`}>Make a difference today</h2>
          <ul className={styles.customLinksWrapper}>
            <HelpOthersCard
              imgSrc="https://www.jg-cdn.com/cms/umbraco/5539/raise-money-for-charity.jpg"
              title="Raise money for charity"
              description="Choose from over 20,000 charities, we’ll send the money
            directly to them"
              href="https://www.justgiving.com/onesearch/pagecreation/charity"
              btnLink="Start fundraising"
              visuallyHidden={true}
              visuallyHiddenText="Start fundraising for a charity"
            />
            <HelpOthersCard
              imgSrc="https://www.jg-cdn.com/cms/umbraco/5537/donate-to-charity.jpg"
              title="Donate to charity"
              description="Support a charity with a one-off or monthly donation"
              href="https://www.justgiving.com/inspiration/how-to-help/cost-of-living-crisis/donate-to-a-charity-supporting-people-during-the-cost-of-living-crisis"
              btnLink="Browse charities"
            />
            <HelpOthersCard
              imgSrc="https://www.jg-cdn.com/cms/umbraco/5538/raise-money-for-own-cause.jpg"
              title="Raise money for your own cause"
              description="We pay what you raise into your personal bank account"
              href={config.createCrowdfundingUrl}
              btnLink="Start crowdfunding"
            />
          </ul>
        </section>
      </div>
    </div>
  );
};
